import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isEmpty } from "lodash";
import { clearChildEventDetails } from '../../../actions/event';
import { clearActiveReservationDetails } from '../../../actions/reservation';

import { DateTimeFormatters } from '@showclix-shared-intl';
import { fullDateRangeShort, hourMinute, weekDayMonthDayYear } from '@showclix-shared-intl/dateTimeFormatters';
import { ISOStringToDate } from '../../../../helpers/time';
import ChangeDate from '../components/ChangeDate';
import { isKioskMode } from '../../../selectors/ui';
import { getLowInventoryMessage } from '../../series/selectors/eventSeries';
import { isSeatedListing } from '../../../selectors/reserved-seating';
import { setShowPyosPicker, setShowBestAvailablePicker } from '../../../actions/ui';
import { TranslationContext } from '../../../../checkout/config/Translations';
import { withRouterCompat } from '@checkout-h/withRouterCompat';
import { changeDateInternal } from '@checkout-v/series/actions/event-series';

class ChangeDateContainer extends Component {

    render() {

        if ((this.props.soldItemsCount !== 0 && !this.props.isSeatedListing) || !this.props.childEvent) {
            return null;
        }

        return(
          <TranslationContext.Consumer>
            {translation =>
              <ChangeDate
                  displayDate={this.getDisplayDate()}
                  displayTime={this.getDisplayTime()}
                  lowInventoryMessage={this.props.getLowInventoryMessage((this.props.selectedEventTimeObject ? this.props.selectedEventTimeObject.inventory : null), translation)}
                  onClick={this.onClick}
                  isKiosk={this.props.isKioskMode}
                  hideChangeButton={!!this.props.hideChangeButton}
                  seriesChildAdditionalInfo={this.props.seriesChildAdditionalInfo}
              />
            }
          </TranslationContext.Consumer>
        )
    }

    onClick = () => {
        if (this.props.childEvent) {
            this.props.clearChildEventDetails();
            // presale
            if (this.props.reservationActive) {
                this.props.clearActiveReservationDetails();
            }
        }
        this.props.changeDateInternal();
        this.props.setShowPyosPicker(false);
        this.props.setShowBestAvailablePicker(false);
        this.props.navigate(this.props.isKioskMode ? '/kiosk-time' : '/day');
    };

    getDisplayTime = () => {
        if (this.props.childEvent === null || Object.keys(this.props.childEvent).length === 0) {
            return "";
        }

        const { hourMinute } = DateTimeFormatters;

        let start = this.props.childEvent.event.start;
        let end   = this.props.childEvent.event.end;

        start = ISOStringToDate(start);

        if (end) {
            end = ISOStringToDate(end);
            return hourMinute(this.props.locale, start) + ' - ' + hourMinute(this.props.locale, end);
        }

        return hourMinute(this.props.locale, start);
    }

    getDisplayDate = () => {
        if (this.props.childEvent === null || Object.keys(this.props.childEvent).length === 0) {
            return "";
        }
        let start = this.props.childEvent.event.start;
        let end   = this.props.childEvent.event.end;
       return formatDisplayDateForChangeDateButton(start, end, this.props.locale, this.props.kioskMode);
    };
}

export const formatDisplayDateForChangeDateButton = (start, end, locale, kioskMode = false) => {
    const { fullDateShort, weekDayMonthDayYear } = DateTimeFormatters;

    let startDate = ISOStringToDate(start);

    if (kioskMode) {
        return weekDayMonthDayYear(locale, startDate);
    }

    if (end) {
        let endDate = ISOStringToDate(end);
        return fullDateRangeShort(locale, startDate, endDate);
    }

    return fullDateShort(locale, startDate);
}

const mapStateToProps = (state, props) => {
    return {
        locale: state.intl.locale,
        soldItemsCount: (state.reservation.items_count !== undefined) ? state.reservation.items_count : 0,
        childEvent: (!isEmpty(state.event.childEvent)) ? state.event.childEvent : null,
        isKioskMode: isKioskMode(state),
        selectedEventTimeObject: state.eventSeries.selectedEventTimeObject,
        getLowInventoryMessage: getLowInventoryMessage(state),
        isSeatedListing: isSeatedListing(state), // show this for seated listings before checkout
        seriesChildAdditionalInfo: state.eventSeries.seriesChildAdditionalInfo
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        clearChildEventDetails,
        clearActiveReservationDetails,
        setShowPyosPicker,
        setShowBestAvailablePicker,
        changeDateInternal
    },
    dispatch);
}

export default withRouterCompat(connect(mapStateToProps, mapDispatchToProps)(ChangeDateContainer))
